<template>
  <div>
    <v-dialog v-model="show" max-width="600" persistent>
      <v-card>
        <v-card-title class="headline"> Relatórios </v-card-title>

        <v-divider />
        <v-card-text>
          <v-container>
            <v-data-table
              :items="relatorios"
              :headers="headers"
              :footer-props="footerProps"
              :loading="loading"
              no-data-text="Nenhum relatório encontrado."
              no-results-text="Nenhum relatório encontrado."
            >
              <template v-slot:[`item.action`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" :disabled="loading">
                      <v-icon small color="blue" @click="abrirModalCamposExtra(item)">file_download</v-icon>
                    </v-btn>
                  </template>
                  <span>Download</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-divider class="mt-n8" />
        <v-card-actions>
          <v-spacer />
          <div class="my-1">
            <v-btn color="red" dark @click="fecharModal()">Fechar</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ModalCamposExtra
      :showModalCamposExtra="showModalCamposExtra"
      :camposExtra="camposExtra"
      :relatorio="relatorioSelecionado"
      @fecharModal="showModalCamposExtra = false"
      @download="download"
    />
  </div>
</template>

<script>
import RelatorioService from "@/service/RelatorioService";
import { saveAs } from "file-saver";
import ModalCamposExtra from "./ModalCamposExtra.vue";

export default {
  name: "ModalRelatorio",

  components: { ModalCamposExtra },

  props: {
    show: Boolean,
    fechar: Function,
    idMenu: Number,
    idChave: Number,
    nome: String,
    showMessage: Function,
  },

  data() {
    return {
      footerProps: {
        itemsPerPageText: "Itens por página:",
        itemsPerPageOptions: [10, 20, 50],
      },
      headers: [
        {
          text: "Nome",
          value: "nome",
          sortable: false,
          align: "left",
        },
        {
          text: "Download",
          value: "action",
          align: "center",
          sortable: false,
          width: "120px",
        },
      ],
      loading: false,
      relatorios: [],
      camposExtra: [],
      showModalCamposExtra: false,
      relatorioSelecionado: null,
      camposExtraExists: false,
    };
  },

  methods: {
    abrirModalCamposExtra(relatorio) {
      if (this.camposExtra && this.camposExtra.length > 0 && this.camposExtraExists) {
        this.showModalCamposExtra = true;
        this.relatorioSelecionado = relatorio;
      } else {
        this.download(relatorio);
      }
    },

    async inicializa() {
      try {
        this.camposExtraExists = false;
        this.loading = true;
        const response = await RelatorioService.consultarPorMenu(this.idMenu);
        this.relatorios = response.data;

        if (this.relatorios && this.relatorios[0].camposExtra && this.relatorios[0].camposExtra.length > 0) {
          this.camposExtra = this.relatorios[0].camposExtra;
          this.camposExtraExists = true;
        }
      } catch (err) {
        console.error(err);
        this.showMessageModal(err.message, "error");
      } finally {
        this.loading = false;
      }
    },
    async download(rel, camposExtras) {
      try {
        this.loading = true;

        const response = await RelatorioService.gerarRelatorioComChave(rel.id, this.idChave, camposExtras);
        const blob = new Blob([response.data], { type: "application/pdf" });
        saveAs(blob, `${rel.nome}${this.nome ? " - " + this.nome : ""}.pdf`);
      } catch (err) {
        console.error(err);
        if (err.code == 14001) {
          this.showMessageModal("Relatório não existe!", "error");
        } else if (err.code == 14002) {
          this.showMessageModal("Relatório não está parametrizado corretamente!", "error");
        } else if (err.code == 14003) {
          this.showMessageModal("Você não tem permissão para ver esse relatório!", "error");
        } else {
          this.showMessageModal(err.message, "error");
        }
      } finally {
        this.loading = false;
      }
    },
    showMessageModal(message, type) {
      if (this.showMessage) {
        this.showMessage(message, type);
      }
    },
    fecharModal() {
      this.relatorios = [];
      this.fechar();
    },
  },

  watch: {
    show: function () {
      if (this.show) {
        this.inicializa();
      }
    },
  },
};
</script>
